"use client"

import type React from "react"
import { cn } from "../lib/utils"
import { Badge } from "./ui/badge"

interface UserHistoryItemProps {
  user: any
  isActive: boolean
  chatCount: number
  onUserSelect: (user: any) => void
  t: (key: string) => string
}

export const UserHistoryItem: React.FC<UserHistoryItemProps> = ({
  user,
  isActive,
  chatCount,
  onUserSelect,
  t,
}) => {
  const displayName = user.displayName || user.name;
  const shouldShowUnauthenticated = !displayName || displayName === "null" || String(displayName).trim() === "";

  return (
    <li
      key={user.id}
      onClick={() => onUserSelect(user)}
      className={cn(
        "flex items-center justify-between p-3 mb-1 cursor-pointer rounded-lg border transition-all",
        isActive
          ? "bg-[#F6F7F9] border-[#105BDB] shadow-sm"
          : "bg-white border-[#E5E7EB] hover:bg-[#F6F7F9]"
      )}
    >
      <div className="flex flex-col flex-1 min-w-0">
        <span className="font-medium text-sm text-[#252A32] truncate">
          {shouldShowUnauthenticated ? t("unauthenticated_user") : displayName}
        </span>
        <span className="text-xs text-[#6F7D95] truncate">{user.phone}</span>
      </div>

      {/* {chatCount > 0 && (
        <Badge
          variant="secondary"
          className="ml-2 flex-shrink-0 bg-[#EEF2F7] text-[#4A5364] hover:bg-[#EEF2F7] text-xs font-medium px-2 py-0.5"
        >
          {chatCount}
        </Badge>
      )} */}
    </li>
  )
}
